import { render, staticRenderFns } from "./addPosition.vue?vue&type=template&id=306bd575&scoped=true&"
import script from "./addPosition.vue?vue&type=script&lang=js&"
export * from "./addPosition.vue?vue&type=script&lang=js&"
import style0 from "./addPosition.vue?vue&type=style&index=0&id=306bd575&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306bd575",
  null
  
)

export default component.exports